module.exports = __webpack_public_path__ + "static/media/night9.2911db20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night9.jpg
// module id = 39
// module chunks = 0